import { createAction, createReducer } from 'deox';

export interface Iovation {
  url: string | null;
}

const defaultState: Iovation = {
  url: null,
};

export const setIovationUrl = createAction(
  'SET_IOVATION_URL',
  resolve => (url: string) => resolve(url),
);

export const iovationReducer = createReducer(defaultState, handleAction => [
  handleAction(setIovationUrl, (state, { payload: url }) => ({
    ...state,
    url,
  })),
]);

interface MountedState {
  iovation: Iovation;
}

export const selectIovationUrl = (state: MountedState): string => {
  if (!state.iovation.url)
    throw new Error('Expect the Iovation URL to have been provided');

  return state.iovation.url;
};

export default iovationReducer;
